import { Subscription, WorkspaceProfile } from "@supernova-studio/model";
import { z } from "zod";
import { DTONpmRegistryConfig } from "./npm-registry";

//
// Read
//

export const DTOWorkspaceProfile = WorkspaceProfile;

export const DTOWorkspace = z.object({
  id: z.string(),
  profile: DTOWorkspaceProfile,
  subscription: Subscription,
  npmRegistry: DTONpmRegistryConfig.optional(),
});

export type DTOWorkspaceProfile = z.infer<typeof DTOWorkspaceProfile>;
export type DTOWorkspace = z.infer<typeof DTOWorkspace>;

//
// Write
//

export const DTOWorkspaceCreateInput = z.object({
  name: z.string(),
});

export const DTOWorkspaceResponse = z.object({
  workspace: DTOWorkspace,
});

export type DTOWorkspaceCreateInput = z.infer<typeof DTOWorkspaceCreateInput>;
export type DTOWorkspaceResponse = z.infer<typeof DTOWorkspaceResponse>;
